__turbopack_context__.v({
  "activeCount": "FacetFilter-module-scss-module__Ga01Aq__activeCount",
  "checkbox": "FacetFilter-module-scss-module__Ga01Aq__checkbox",
  "chevron": "FacetFilter-module-scss-module__Ga01Aq__chevron",
  "count": "FacetFilter-module-scss-module__Ga01Aq__count",
  "expanded": "FacetFilter-module-scss-module__Ga01Aq__expanded",
  "facet": "FacetFilter-module-scss-module__Ga01Aq__facet",
  "header": "FacetFilter-module-scss-module__Ga01Aq__header",
  "label": "FacetFilter-module-scss-module__Ga01Aq__label",
  "labelWrapper": "FacetFilter-module-scss-module__Ga01Aq__labelWrapper",
  "name": "FacetFilter-module-scss-module__Ga01Aq__name",
  "option": "FacetFilter-module-scss-module__Ga01Aq__option",
  "values": "FacetFilter-module-scss-module__Ga01Aq__values",
});
